<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-form @submit.prevent="submitForm" id="new-patient-form">
    <v-layout
      justify-center
      wrap
    >

      <v-flex
        xs12
        md8
      >

        <material-card
          color="green"
          title="تعديل معلومات المراجع"
          text="يرجى ادخال معلومات المراجع  المراد تعديلها و تدقيقها قبل عملية الإرسال"
        >

            <v-container py-0>
                <v-progress-circular
                        v-show="isloading"
                        :size="70"
                        :width="7"
                        color="purple"
                        indeterminate
                ></v-progress-circular>
              <v-layout wrap>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                  v-model="fullname"
                    label="إسم الطفل الرباعي"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                  v-model="mothername"
                    class="purple-input"
                    label="إسم الأم الرباعي"
                  />
                </v-flex>
               <v-flex
                   xs12
                   md4>
                   <v-autocomplete
                       :items="this.$store.state.iraqprovs"
                       v-model="province"
                       label="المحافظة"
                   ></v-autocomplete>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                  v-model="district"
                    label="القضاء"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                  v-model="sector"
                    label="المحلة"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                  v-model="street"
                    label="الزقاق"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                  v-model="houseno"
                    label="الدار"
                    class="purple-input"/>
                </v-flex>

                <v-flex
                  xs12
                  md4>
                    <v-autocomplete
                        :items="this.$store.state.sexitems"
                        v-model="sex"
                        label="الجنس"
                    ></v-autocomplete>
                </v-flex>
                <v-flex
                   xs12
                   md4>

                      <v-select
                              :items="this.$store.state.pregages"
                              v-model="pregage"
                              class="purple-input"
                              label="العمر الحملي"/>
                </v-flex>


                <v-flex
                        xs12
                        md4>

                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-text-field
                              v-on="on"
                              readonly
                              v-model="birthdate"
                              class="purple-input"
                              label="تاريخ الميلاد"/>

                    </template>
                    <v-date-picker dark v-model="birthdate" />
                  </v-menu>
                </v-flex>

                <v-flex
                        xs12
                        md4>
                  <v-text-field
                  v-model="mobile"
                          class="purple-input"
                          label="رقم الهاتف"/>
                </v-flex>

                <v-flex
                        xs12
                        md4>
                  <v-checkbox
                  v-model="twin"
                          label="تؤام ؟"
                          color="success"
                  />
                </v-flex>



                <v-flex xs12>
                  <v-textarea

                    class="purple-input"
                    label="ملاحظات عامة"
                  />
                </v-flex>

              </v-layout>
            </v-container>

        </material-card>
      </v-flex>

          <v-flex
                  md12
                  xs12
                  text-xs-right
                    >
                    <v-btn
                     type="submit" form="new-patient-form"
                    class="mx-0 font-weight-bold"
                    color="success"
                    >
             حفظ التغييرات
            </v-btn>
          </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import Axios from 'axios'
import {__GET_AS_LIST} from '@/utils/utils'

  export default {
    data: () => ({
      isloading: true,
      picker: new Date().toISOString().substr(0, 10),
      date: new Date().toISOString().substr(0, 10),
      birthtime: '',
      fullname: '',
      sex: null,
      district: '',
      mobile: '',
      birthdate: '',
      houseno: '',
      healthdeps:[],
      street: '',
      sector: '',
      province: null,
      mothername: '',
      menu: false,
      modal: false,
      menu2: false,
      pregage:'',
      twin: null,
      provincetitle: 'بغداد',
    }),
    created() {
      this.getPatientInfo();
      this.getHealthDep();
    },
    methods: {
      getHealthDep() {
        __GET_AS_LIST("healthdep",{},(res) => {
          res.map((i) => {
            this.healthdeps.push({text: i.title, value:i.id});
          });
        });
      },
      getPatientInfo() {

        Axios.post("https://cphl.esite-lab.com/api.php?do=getpatientinfo&id="+this.$route.query.pid).then((res) => {
            this.isloading = false
          if (res.data.auth == true) {
            this.fullname = res.data.fullname
            this.birthplace = res.data.birthplace
            this.province =  res.data.province
            this.sex =  res.data.sex
            this.pregage = res.data.pregage
            this.twin = res.data.twin === 1
            this.mothername = res.data.mothername
            this.district = res.data.district
            this.houseno = res.data.houseno
            this.street = res.data.street
            this.sector = res.data.sector
            this.birthdate = res.data.birthdate
            this.mobile = res.data.mobile

          }
        })
      },

      submitForm() {
        Axios.post("https://cphl.esite-lab.com/api.php?do=editpatient",{
          birthtime: this.birthtime,
          fullname: this.fullname,
          sex: this.sex,
          district: this.district,
          mobile: this.mobile,
          birthdate: this.birthdate,
          houseno: this.houseno,
          street: this.street,
          sector: this.sector,
          province: this.province,
          mothername: this.mothername,
          pregage: this.pregage,
          twin: this.twin ? 1 : 0,
          birthplace: '',
          id: this.$route.query.pid
        }, {
          headers: {
            'Content-Type': "application/x-www-form-urlencoded"
          }
        }).then((res) => {
            console.log(this.sex);
            if (res.data.auth == true) {
              this.$router.push({path: '/list-patients'})
            }
        })
      }
    }
  }
</script>
